<template>
  <div>
    <input v-model="firstName" pattern="^[a-zA-Z'\.,\- ]+$" title="Invalid First Name, only alphabetic characters allowed" type="text" class="nissan-quiz-input" id="nissan-quiz-firstname" name="firstname" placeholder="First Name" required />
    <input v-model="lastName" pattern="^[a-zA-Z'\.,\- ]+$" title="Invalid Last Name, only alphabetic characters spaces and hyphens allowed" type="text" class="nissan-quiz-input" id="nissan-quiz-lastname" name="lastname" placeholder="Last Name" required />
    <input v-model="email" pattern="^[a-zA-Z_0-9\-'\+~]+(\.[a-zA-Z_0-9\-'\+~]+)*@([a-zA-Z_0-9\-]+\.)+[a-zA-Z]{2,7}$" title="Invalid email" type="email" class="nissan-quiz-input" id="nissan-quiz-email" name="email" placeholder="e-mail" required />
    <input v-model="zip" pattern="^\d{5}$" title="Only Numbers Allowed" type="text" size="5" maxlength="5" class="nissan-quiz-input" id="nissan-quiz-zip" name="zip" placeholder="Zip" required v-if="this.config.tierType !== 'CORP'" />
  </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserRegistration',
  computed: {
    ...mapGetters([
      'config',
    ]),
    firstName: {
      get() {
        return this.$store.state.firstName;
      },
      set(value) {
        this.$store.commit('setFirstName', { value });
      },
    },
    lastName: {
      get() {
        return this.$store.state.lastName;
      },
      set(value) {
        this.$store.commit('setLastName', { value });
      },
    },
    email: {
      get() {
        return this.$store.state.email;
      },
      set(value) {
        this.$store.commit('setEmail', { value });
      },
    },
    zip: {
      get() {
        return this.$store.state.zip;
      },
      set(value) {
        this.$store.commit('setZip', { value });
      },
    },
  },
};
</script>


<style scoped lang="scss">
@import '../../styles/_variables.scss';
@import '../../styles/_reset.scss';


input.nissan-quiz-input {
  position: relative;
  display: block;
  background-color: transparent;
  border-bottom: 2px solid #FFF;
  width: 90%;
  color: #FFF;
  font-size: 16px;
  height: 30px;
  text-align: center;
  font-weight: bold;
  line-height: 18px;
  text-transform: uppercase;
  margin: 5px auto 0;
  padding: 8px 0;
  &::placeholder {
    color: #fff;
  }
}
@media only screen and (min-width: 600px) {
  input.nissan-quiz-input {
    height: 45px;
  }
}
@media only screen and (max-width: 320px) {
  input.nissan-quiz-input {
    height: 25px;
  }
}
</style>
